
import { format } from "date-fns";
import { Globe } from "lucide-react";

interface ProfileDetailsProps {
  profile: {
    created_at?: string;
    timezone?: string;
    phone_number?: string;
    [key: string]: any;
  } | null;
}

const ProfileDetails = ({ profile }: ProfileDetailsProps) => {
  if (!profile) {
    return <div className="text-center py-4 text-gray-500">Profile information not available</div>;
  }

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium mb-4">Account Information</h3>
        
        <div className="space-y-4">
          <div>
            <p className="text-sm text-gray-500">Phone Number</p>
            <p className="font-medium">{profile.phone_number || "Not specified"}</p>
          </div>
          
          <div>
            <p className="text-sm text-gray-500">Registered On</p>
            <p className="font-medium">
              {profile.created_at 
                ? format(new Date(profile.created_at), "PPP") 
                : "Unknown"}
            </p>
          </div>
          
          <div className="flex items-center">
            <Globe className="h-4 w-4 mr-2 text-gray-500" />
            <div>
              <p className="text-sm text-gray-500">Timezone</p>
              <p className="font-medium">{profile.timezone || "Not specified"}</p>
            </div>
          </div>
          
          <div>
            <p className="text-sm text-gray-500">Subscription Status</p>
            <div className={`inline-block px-2 py-1 rounded text-xs ${
              profile.subscription_status === 'active' 
                ? 'bg-green-100 text-green-800' 
                : 'bg-gray-100 text-gray-800'
            }`}>
              {profile.subscription_status === 'active' ? 'Active' : 'Inactive'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileDetails;
